import React from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "../components/Pages/HomePage";
import NotFound from "../components/Pages/NotFound";
import Layout from "../components/library/Layout";
import PrivateRoute from "../Authentication/PrivateRoute";
import Notifications from "../components/Pages/Notifications";
import SignIn from "../Authentication/SignIn";
import Settings from "../components/Pages/Settings";
import Product from "../components/Pages/Product";
import Suppliers from "../components/Pages/Suppliers";
import Consumers from "../components/Pages/Consumers";
import Movement from "../components/Pages/Movement";
import OrderProducts from "../components/Pages/OrderProducts";
import MaterialReturning from "../components/Pages/MateriaIReturning";
import Business from "../components/Pages/Business";
import Dashboard from "../components/Pages/Dashboard";
import RequestedProducts from "../components/Pages/RequestedProducts";
import MateriaIssue from "../components/Pages/MateriaIssues";
import ExtendCard from "../components/Pages/AllParchasedOrder";
import UsersPrivilege from "../components/Pages/UsersPrivilege";
import RequestedMaterials from "../components/Pages/RequestedMaterials";
import PDFGenerator from "../components/Pages/PDF/PDFGenerator";
import Categories from "../components/Pages/Categories";
import Units from "../components/Pages/Units";
import AllParchasedOrderReports from "../components/Pages/AllParchasedOrderReports";
import MovementReport from "../components/Pages/MovementReport";

const AppRoutes = () => {
    return (
        <div>
            <Routes>
                <Route element={<Layout />}>
                    <Route index="/" element={<PrivateRoute><HomePage /></PrivateRoute>} />
                    <Route path="/categories" element={<PrivateRoute>  <Categories /></PrivateRoute>} />
                    <Route path="/product" element={<PrivateRoute>  <Product /></PrivateRoute>} />
                    <Route path="/units" element={<PrivateRoute>  <Units /></PrivateRoute>} />
                    <Route path="/supplier" element={<PrivateRoute>  <Suppliers /></PrivateRoute>} />
                    <Route path="/consumer" element={<PrivateRoute>  <Consumers /></PrivateRoute>} />
                    <Route path="/view_stock_movement" element={<PrivateRoute>  <Movement /></PrivateRoute>} />
                    <Route path="/orders" element={<PrivateRoute>  <OrderProducts /></PrivateRoute>} />
                    <Route path="/requested_products" element={<PrivateRoute>  <RequestedProducts /></PrivateRoute>} />
                    <Route path="/materialissuing" element={<PrivateRoute>  <MateriaIssue /></PrivateRoute>} />
                    <Route path="/materialreturning" element={<PrivateRoute>  <MaterialReturning /></PrivateRoute>} />
                    <Route path="/business" element={<PrivateRoute>  <Business /></PrivateRoute>} />
                    <Route path="/dashboard" element={<PrivateRoute>  <Dashboard /></PrivateRoute>} />
                    <Route path="/recieved_requested_products" element={<PrivateRoute>  <ExtendCard /></PrivateRoute>} />
                    <Route path="/requested_products_reports" element={<PrivateRoute>  <AllParchasedOrderReports /></PrivateRoute>} />
                    <Route path="/ordered_products_reports" element={<PrivateRoute>  <MovementReport /></PrivateRoute>} />
                    <Route path="/materials" element={<PrivateRoute>  <RequestedMaterials /></PrivateRoute>} />
                    <Route path="/pdf" element={ <PDFGenerator />} />y
                    


                    <Route path="/roles" element={<PrivateRoute>  <UsersPrivilege /> </PrivateRoute>} />
                    <Route path="/notifications" element={<PrivateRoute>  <Notifications /></PrivateRoute>} />
                    <Route path="/settings" element={<PrivateRoute>  <Settings /></PrivateRoute>} />
                </Route>
                <Route path="/signin" element={<SignIn />} />
                <Route path='*' element={<NotFound />} />
            </Routes>

        </div>
    )
}

export default AppRoutes